module.exports = __webpack_public_path__ + "static/media/hero-image.138d050f.png";